export default __webpack_public_path__ + "static/logo-lwl-1f2d942469e9e17d32c44b5b5725830d.png";